/**
 * Typography 토큰 — 7 단계 타입 스케일
 */

export const typography = {
  fontSize: {
    'display-lg': '48px',
    'display-md': '36px',
    'display-sm': '28px',
    'h1': '24px',
    'h2': '20px',
    'h3': '16px',
    'body-lg': '16px',
    'body-md': '14px',
    'body-sm': '13px',
    'caption': '12px',
  } as const,

  fontWeight: {
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  } as const,

  lineHeight: {
    tight: 1.2,
    snug: 1.25,
    normal: 1.3,
    relaxed: 1.35,
    loose: 1.4,
    body: 1.5,
    relaxedBody: 1.6,
  } as const,
} as const

export type FontSizeKey = keyof typeof typography.fontSize
export type FontWeightKey = keyof typeof typography.fontWeight
export type LineHeightKey = keyof typeof typography.lineHeight
